<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem }"
    custom-export-url="/show-places/export/"
    has-availabilities
  >
    <template v-slot:form="{ editedItem, error }">
      <v-row>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.place"
            :error-messages="error.place"
            :model="placeModel"
            item-text="name"
            item-value="id"
            label="Luogo"
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="editedItem.status"
            :error-messages="error.status"
            :items="[
              { value: 1, text: 'selezionato' },
              { value: 2, text: 'contattato' },
              { value: 3, text: 'approvato' },
            ]"
            label="Stato"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.internal_referent"
            :error-messages="error.internal_referent"
            :model="personModel"
            item-text="name"
            item-value="id"
            label="Referente interno"
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.company"
            :error-messages="error.company"
            label="Azienda"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.contact"
            :error-messages="error.contact"
            label="Contatto"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.price"
            :error-messages="error.price"
            label="Prezzo"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <p v-if="editedItem.place__notes">
        <b>Note luogo:</b>
        {{ editedItem.place__notes }}
      </p>
    </template>

    <template v-slot:item.status="{ item }">
      <status-indicator small :status="item.status" />
    </template>
    <template v-slot:item.export="{ item }">
      <router-link
        :to="{
          name: 'ExportPlace',
          params: { id: modelFk.show, placeId: item.id },
        }"
      >
        Esporta
      </router-link>
    </template>
  </generic-update-list>
</template>

<script>
import models from "@/models"
import statuses from "@/statuses"

export default {
  data() {
    return {
      modelHeaders: [
        { text: "Luogo", value: "place__name" },
        { text: "Stato", value: "status" },
        { text: "Esporta", value: "export" },
      ],
      model: models.ShowPlace,
      placeModel: models.Place,
      personModel: models.Person,
      statuses,
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      availabilities: [],
      place: null,
      internal_referent: null,
      company: "",
      contact: "",
      price: 0,
    }),
  },
}
</script>
